module.exports = __webpack_public_path__ + "img/album14_41.10b0474e.jpg";